
















import Vue, { PropOptions } from 'vue'
import Loader from '@/components/Loader.vue'
import PullsCard from '@/components/PullsCard.vue'
import Button from '@/components/Button.vue'
import NoContent from '@/components/NoContent.vue'
import { Subtab, PullRequest, ApiData } from '@/interfaces'
import { AppHub } from '@/event-hub'
import { logUserActivity } from '@/services/AppInsights'

export default Vue.extend({
  name: 'PullDetailPage',
  components: { Button, PullsCard, Loader, NoContent },
  data() {
    return {
      fromRoutePath: '',
    }
  },
  created() {
    AppHub.$on('refresh', this.fetchData)
    this.fetchData()
    logUserActivity(this.$route.name!, this.pullId)
  },
  mounted() {
    this.setSubTab()
  },
  beforeDestroy() {
    AppHub.$off('refresh', this.fetchData)
  },
  computed: {
    currentSubtab(): any {
      return this.pullRequest.data && this.pullRequest.data.status === 'Pending'
        ? 'pending'
        : 'history'
    },
    accountId(): string {
      return this.$store.state.accountId
    },
    pullRequest(): ApiData<PullRequest> {
      return this.$store.getters.getPullRequestById(this.pullId)
    },
  },
  methods: {
    goBack() {
      this.fromRoutePath && !this.fromRoutePath.includes('pull-inventory')
        ? this.$router.push(this.fromRoutePath)
        : this.$router.push(`/${this.accountId}/pulls`)
    },
    fetchData() {
      this.$store.dispatch('fetchPullRequestById', this.pullId)
    },
    setSubTab() {
      const subtabState = { parent: 'pulls', subtab: this.currentSubtab }
      this.$store.commit('setCurrentSubtab', subtabState)
    },
  },
  watch: {
    pullRequest() {
      this.setSubTab()
    },
  },
  props: {
    pullId: {
      type: String,
      default: () => '',
    } as PropOptions,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      ;(vm as any).fromRoutePath = from.name ? from.path : ''
    })
  },
})
